// All user-management related apis
import instance, { API_URL } from "./api";
import { encryptData } from "../helpers/encryptDecrypt";

// Get api for fetching all the users (not in use)
export const fetchUsers = async () => {
  return await instance.get(`${API_URL}/users`);
};

// Get api for fetching user's details with ID (not in use)
export const fetchUser = async (userId) => {
  const uId = encryptData(userId);
  return await instance.get(`${API_URL}/users/${uId}`);
};

// Get api for fetching all the branches for the active organization (not in use)
export const fetchBranches = async (organizationId) => {
  const oId = encryptData(organizationId);
  return await instance.get(`${API_URL}/organizations/${oId}/branches`);
};

// Put api for updating the user's link with the available organization's branches
export const updateUserBranches = async (userId, branchIds) => {
  const uId = encryptData(userId);
  return await instance.put(`${API_URL}/users/${uId}/branches`, { branchIds });
};

// Post api for updating the selected user's details
export const updateUserDetails = async (userId, userData) => {
  const uId = encryptData(userId);
  return await instance.post(`${API_URL}/users/edit-user/${uId}`, userData);
};

// Post api for updating the new status of the user
export const updateUserNewStatus = async (userId) => {
  const uId = encryptData(userId);
  return await instance.post(
    `${API_URL}/users/update-user-new-status/${uId}`,
    {}
  );
};

// Post api for updating the product's tour status of the user
export const updateTourProductStatus = async (userId) => {
  const uId = encryptData(userId);
  return await instance.post(
    `${API_URL}/users/update-product-tour-status/${uId}`,
    {}
  );
};

// Post api for updating the sale's tour status of the user
export const updateTourSalesStatus = async (userId) => {
  const uId = encryptData(userId);
  return await instance.post(
    `${API_URL}/users/update-sales-tour-status/${uId}`,
    {}
  );
};

// Post api for updating the checkout's tour status of the user
export const updateTourCheckoutStatus = async (userId) => {
  const uId = encryptData(userId);
  return await instance.post(
    `${API_URL}/users/update-checkout-tour-status/${uId}`,
    {}
  );
};

// Post api for adding the new user to the active organization
export const addUserToOrganization = (organizationId, userId) => {
  const oId = encryptData(organizationId);
  return instance.post(`${API_URL}/organizations/${oId}/add-user`, {
    user_id: userId,
  });
};

// Post api for adding the new user to the active branch
export const addUserToBranch = (branchId, userId) => {
  const bId = encryptData(branchId);
  return instance.post(`${API_URL}/branches/${bId}/add-user`, {
    user_id: userId,
  });
};

// Get api for fetching all the users of the active organization with the option of filter with search keyword
export const fetchUsersByOrganization = (organizationId, keyword) => {
  const oId = encryptData(organizationId);
  return instance.get(
    `${API_URL}/organizations/${oId}/users?keyword=${keyword}`
  );
};

// Post api for updating the selected user's password
export const updateUserPassword = async (userId, userData) => {
  const uId = encryptData(userId);
  return await instance.post(
    `${API_URL}/auth/change-password/${uId}`,
    userData
  );
};

// Delete api for deleting the existing user's account
export const deleteUserAccount = async (userId, source) => {
  const uId = encryptData(userId);
  return await instance.delete(
    `${API_URL}/auth/delete-account/${uId}?source=${source}`
  );
};
